<template>
  <a-modal title="确认收货" width="90%" v-model="openDialog" :footer="null">
    <div class="a-modal-div1">
      <div class="dialog-container">
        <a-form label-width="80px" class="UniformCss">
          <a-row>
            <a-col :span="4">
              <a-form-item label="订单编号">
                <a-input v-model="order.applyOrderCode" disabled />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="收货日期">
                <a-input v-model="order.receiveTime" disabled />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="收货确认人">
                <a-input v-model="order.receiveMan" disabled />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="8">
              <a-form-item label="申领部门">
                <a-input v-model="order.orgName" disabled />
              </a-form-item>
            </a-col> -->
            <a-col :span="4">
              <a-form-item label="订单总项数">
                <a-input v-model="order.orderMaterialCount" disabled />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="8">
              <a-form-item label="订单总数量">
                <a-input v-model="order.orderNums" disabled />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="订单总金额">
                <a-input v-model="order.orderTotalSums" disabled />
              </a-form-item>
            </a-col> -->
            <a-col :span="4">
              <a-form-item label="审批数量">
                <a-input v-model="order.approveNums" disabled />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="审批总金额">
                <a-input v-model="order.approveTotalSums" disabled />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="8">
              <a-form-item label="评审意见">
                <a-input v-model="order.approveInfo" disabled />
              </a-form-item>
            </a-col> -->
          </a-row>
        </a-form>
      </div>
      <div>

        <div class="logistics-table">
          <h4 style="margin: 16px 0; font-weight: bold;">物料信息表</h4>
        <vxe-table
          :data="materialtable"
          border
          show-header-overflow
          show-overflow
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6'}"
          :select-config="{
         checkField: 'checked',
         trigger: 'row',
         highlight: true,
         reserve: true
        }"
        >
          <!-- <vxe-table-column type="checkbox"  width="55" align="center" /> -->
          <vxe-table-column field="materialCode" title="物料号" width="200" align="center" />
          <vxe-table-column field="materialName" title="物料名称" width="250" align="center" />
          <vxe-table-column field="price" title="申领价" width="100" align="center" />
          <vxe-table-column field="nums" title="申领数量" width="100" align="center" />
          <vxe-table-column field="totalSums" title="申领总金额" width="100" align="center" />
          <vxe-table-column field="approveNums" title="审批数量" width="100" align="center" />
          <vxe-table-column field="approveTotalSums" title="审批总金额" width="100" align="center" />
          <vxe-table-column field="applyRemarks" title="申领备注" width="375" align="center" />
        </vxe-table>
      </div>
        
        <div class="logistics-table">
          <h4 style="margin: 16px 0; font-weight: bold;">物流信息表</h4>
          <vxe-table
            :data="OrderLogistics"
            border
            show-header-overflow
            show-overflow
            style="width: 100%"
            :header-cell-style="{background:'#eef1f6', fontWeight: 'bold'}"
            :row-style="{height: '40px'}"
            @checkbox-change="handleSelectionChange"
          >
            <vxe-table-column type="checkbox" width="55" align="center" />
            <!-- <vxe-table-column field="id" title="物流ID" width="120" align="center" /> -->
            <!-- <vxe-table-column field="logisticsOrderCode" title="物料单ID" width="130" align="center" /> -->
            <vxe-table-column field="trackingNumber" title="物流单号" width="650" align="center" />
            <!-- :formatter="({ cellValue }) => cellValue === 0 ? '未收货' : '已收货'" -->
            <vxe-table-column 
              field="status" 
              title="物流状态" 
              width="620"
              align="center"
              :formatter="({ cellValue }) => cellValue === '0' ? '未收货' : '已收货'" 
            />
          </vxe-table>
        </div>
        
      </div>
      <div class="btn-container">
        <vxe-button @click="$emit('update:visible', false)">返回</vxe-button>
        <vxe-button status="primary" @click="$emit('receiveSubmit',selection)">收货确认</vxe-button>
        <!-- <vxe-button status="primary" @click="$emit('receiveSubmit',receiveMaterialParam)">收货确认</vxe-button> -->

      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: 'ReceiveMaterialDialog',

  // eslint-disable-next-line vue/require-prop-types
  props: ['visible', 'order', 'materialtable','OrderLogistics'],
  data() {
    return {
      multipleSelection: [],
      // receiveMaterialParam: {
      //   selectedItems: [],
      //   Id: null
      // }
    }
  },
  computed: {
    // :visible.sync="receiveDialog 父传子
    openDialog: {
      get() {
        // 返回父组件传递的visible属性值
        return this.visible
      },
      set(val) {
        // 当值变化时，触发update:visible事件通知父组件
        this.$emit('update:visible', val) 
      }
    }
  },
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    // 将当前选择的行数据赋值给组件的selection属性
    // handleSelectionChange(val) {
    //   this.selection = val
    //   console.log(val,"val")

    //   console.log(this.selection,"this.selection")
    //   }
      handleSelectionChange(selection) {
      this.selection = selection
      console.log(this.selection,"this.selection")
      }
      // handleSelectionChange(row) {
      // this.selection = row
      // console.log(this.selection,"this.selection")
      // }
    }
}

</script>
<style lang="less" scoped>
.a-modal-div1{
  width: 100%;
  height: 80vh;
}
.dialog-container {
    width: 100%;
}
.btn-container {
  margin-top: 20px;
  text-align: center;
}

</style>
